<ng-container>
  <div appWindowHeightDirective class="menu-container" id="menuScroll">
    <div class="header-sticky-container">
      <app-mobileheaderlayoutdesktop
        [brownarrow]="true"
        [currentLanguage]="currentLanguage"
        (stateValue)="onCloseClick('close')"
      ></app-mobileheaderlayoutdesktop>
    </div>
    <div class="header-container">
      <img
        class="favorites-fill"
        [appImageSprite]="'favorites_fill'"
        [params]="common_icons"
      />
      <span class="favorites-header-text lang-specific-font-name">{{
        'LANG00825' | translate
      }}</span>
      <img
        class="header-menu-icon"
        [ngClass]="'header-menu-icon-' + currentLanguage"
        [appImageSprite]="'menu_back_arrow_white'"
        [params]="menu_icons"
        (click)="onCloseClick($event)"
      />
    </div>

    <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
      <table
        class="favorites-container background-auto-height"
        *ngFor="let item of favoritesList; let i = index"
        cdkDrag
      >
        <img
          class="vertical-line"
          [appImageSprite]="'vertical_line_fav'"
          [params]="menu_icons"
        />
        <tbody>
          <tr class="favoritedetails-tablerow">
            <td class="favoritedetails-column-image1">
              <img
                [ngClass]="{
                  'favoritedetails-column-img1':
                    item.tableType == 'livecasino' ||
                    item.seatavailable == 5 ||
                    item.seatavailable == 3 ||
                    item.seatavailable == 1,
                  'favoritedetails-column-img1-portrait':
                    item.seatavailable == 2 || item.seatavailable == 7
                }"
                [appImageSprite]="
                  deviceImage[
                    item.seatavailable +
                      '_' +
                      (item.seatavailable == 7
                        ? 'device_portrait'
                        : item.device)
                  ]
                "
                [params]="mobile_icons"
              />
            </td>
            <td class="favoritedetails-column-image2">
              <img
                class="favoritedetails-column-img1"
                [appImageSprite]="item.tableType + '_brown'"
                [params]="menu_icons"
              />
            </td>
            <td class="favoritedetails-column-data">
              <div
                class="favoritedetails-column-content lang-specific-font-name lang-specific-favoritedetails-column-content lang-specific-favoritedetails-column-content-gameType"
              >
                {{ item.gameType | translate
                }}{{ item.tableNum ? ' - ' + item.tableNum : '' }}
              </div>
            </td>
            <td class="favoritedetails-column-image3">
              <img
                class="arrow-icon"
                [appImageSprite]="'arrow_icon_brown'"
                [params]="menu_icons"
                (click)="onIconClick('play', i)"
              />
            </td>
          </tr>
          <tr class="favoritedetails-tablerow">
            <td
              class="favoritedetails-column-image1 favorite-memu-middle-row-icon"
            >
              <img
                class="favoritedetails-column-img1 favoritedetails_minbet_brown"
                [appImageSprite]="'minbet_brown'"
                [params]="menu_icons"
              />
            </td>
            <td
              class="favoritedetails-column-image2 favorite-memu-middle-row"
            ></td>
            <td
              class="favoritedetails-column-data favorite-memu-middle-row-bet"
            >
              <div
                *ngIf="item.title != 'newtable'"
                class="favoritedetails-column-content lang-specific-favoritedetails-minmax-content"
                [ngClass]="userCurrency + '-text-content-string'"
              >
                {{ item.min | usercurrency | currencysymbol }}
              </div>
            </td>
            <td
              class="favoritedetails-column-image3 favorite-memu-middle-row"
            ></td>
          </tr>
          <tr class="favoritedetails-tablerow">
            <td class="favoritedetails-column-image1">
              <img
                class="favoritedetails-column-img1 imag2-alignment favoritedetails_maxbet_brown"
                [appImageSprite]="'maxbet_brown'"
                [params]="menu_icons"
              />
            </td>
            <td class="favoritedetails-column-image2"></td>
            <td class="favoritedetails-column-data">
              <div
                *ngIf="item.title != 'newtable'"
                class="favoritedetails-column-content lang-specific-favoritedetails-minmax-content"
                [ngClass]="userCurrency + '-text-content-string'"
              >
                {{ item.max | usercurrency | currencysymbol }}
              </div>
            </td>
            <td class="favoritedetails-column-image3">
              <img
                class="delete imag2-alignment"
                [appImageSprite]="'delete_brown'"
                [params]="menu_icons"
                [currentLanguage]="currentLanguage"
                appToolTip="{{ 'LANG00399' | translate }}"
                (click)="onIconClick('delete', i)"
              />
            </td>
          </tr>
        </tbody>
        <img
          class="rearrange"
          [appImageSprite]="'rearrange_brown'"
          [params]="menu_icons"
          [currentLanguage]="currentLanguage"
          appToolTip="{{ 'LANG00650' | translate }}"
          cdkDragHandle
        />
      </table>
    </div>
    <div class="favorites-container" *ngIf="favoritesList.length <= 0">
      <img
        class="no-records-gold-bg"
        [appImageSprite]="'menu_bg_gold'"
        [params]="menu_icons"
      />
      <span
        *ngIf="currentLanguage == 'en'"
        class="no-records lang-specific-font-name lang-specific-no-records"
        >{{ 'LANG00898' | translate }}</span
      >
      <img
        *ngIf="currentLanguage != 'en'"
        class="no-records-favorites_stroke"
        [appImageSprite]="'favorites_stroke_brown@2x'"
        [params]="common_icons"
      />
    </div>
  </div>

  <div
    class="delete-popup-container"
    *ngIf="isDeletePopup"
    (click)="onDeleteNo($event)"
  >
    <img
      class="delete-popup"
      src="assets/images/common/popup-bg.webp?t={{ version }}"
    />
    <img
      class="favorites-fill-delete lang-specific-mobile-favorites-fill-delete"
      [appImageSprite]="'favorites_fill'"
      [params]="common_icons"
    />
    <span
      class="header-delete-text lang-specific-font-name lang-specific-mobile-header-delete-text"
      [ngStyle]="{
        'text-transform': currentLanguage == 'ge' ? 'none' : 'uppercase'
      }"
    >
      {{ 'LANG00825' | translate }}</span
    >
    <img
      class="delete-popup-icon"
      [appImageSprite]="'delete'"
      [params]="menu_icons"
    />
    <div class="text-make-center delete-text-top">
      <span
        class="delete-text lang-specific-font-name lang-specific-mobile-delete-text"
        >{{ 'LANG00399' | translate }}</span
      >
    </div>
    <div class="text-make-center no-delete-text-top">
      <span
        class="no-delete-text lang-specific-font-name"
        [ngStyle]="{
          'text-transform': currentLanguage == 'ge' ? 'none' : 'uppercase'
        }"
        (click)="onDeleteNo($event)"
        >{{ 'LANG00469' | translate }}</span
      >
    </div>
    <div class="text-make-center yes-delete-text-top">
      <span
        class="yes-delete-text lang-specific-font-name"
        [ngStyle]="{
          'text-transform': currentLanguage == 'ge' ? 'none' : 'uppercase'
        }"
        (click)="onDeleteYes($event)"
        >{{ 'LANG00059' | translate }}</span
      >
    </div>
  </div>
</ng-container>
